import axios from "axios"
import caAPI from "./caAPI"

const guApi = axios.create({
    baseURL: process.env.REACT_APP_GU_API,
    headers: { Authorization: caAPI.getLocalState('guToken') }
})

export const guService = {
    ID_MODULO_CENTRAL_ATENDIMENTO: 6,
    alterarCliente: (idCliente) => guApi.post(`/seleciona-cliente`, { id_cliente: idCliente }),
    acessarModulo: (token, idModulo) => guApi.get(`/cliente-acessar-modulo/${idModulo}`, { headers: { Authorization: token } })
}